import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { ClientWall } from "../site/ClientWall";
import { ReviewList } from "../site/Reviews";
import { Eyebrow, MaskLines } from "../site/Reveal";

export const TrustSection = () => (
  <section data-testid="trust-section" className="bg-paper py-24 sm:py-32">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-12">
        <div>
          <Eyebrow>Clients &amp; voices</Eyebrow>
          <h2 className="mt-6 font-display font-extrabold tracking-[-0.035em] leading-[0.95] text-4xl sm:text-6xl">
            <MaskLines inView lines={[<>Trusted by the <span className="font-serif-i text-[var(--brass-deep)]">regulated.</span></>]} />
          </h2>
        </div>
        <Link to="/clients" data-testid="trust-clients-link" className="group inline-flex items-center gap-2 font-semibold border-b border-ink pb-1 self-start sm:self-auto">
          Clients &amp; reviews <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:rotate-45" />
        </Link>
      </div>
      <ClientWall />
      <div className="mt-12">
        <ReviewList limit={2} />
      </div>
    </div>
  </section>
);
